<ng-container>
  <mat-drawer-container>
    <mat-drawer-content>
      <router-outlet></router-outlet>
    </mat-drawer-content>
  </mat-drawer-container>

  <div
    class="mat-drawer-backdrop"
    [ngClass]="{ 'mat-drawer-shown': drawer.opened }"
  ></div>
  <mat-drawer
    #drawer
    [position]="dir == 'rtl' ? 'start' : 'end'"
    [ngStyle]="drawerConfig?.style"
  >
    <div class="drawer-wrapper">
      <ng-container #drawerContent></ng-container>
    </div>
  </mat-drawer>
</ng-container>
